// Image-URL helper.
// Some end-user networks have intermittent issues reaching the customer-assets CDN directly.
// To eliminate this entirely, we route those images through our own backend (/api/img?u=...),
// which makes them appear same-origin to the browser and removes any CDN/regional flakiness.
//
// Non-CDN URLs (e.g. local /static, data:, blob:) are returned unchanged.

const PROXY_HOSTS = new Set(['customer-assets.emergentagent.com', 'customer-assets-lxgj4vgw.emergentagent.net', 'customer-assets-wrfwihn1.emergentagent.net']);

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export function imgUrl(rawUrl, width) {
  if (!rawUrl || typeof rawUrl !== 'string') return rawUrl;
  // Skip data:, blob: and same-origin paths
  if (/^(data:|blob:|\/)/.test(rawUrl)) return rawUrl;
  try {
    const u = new URL(rawUrl);
    if (PROXY_HOSTS.has(u.hostname)) {
      const base = `${BACKEND_URL}/api/img?u=${encodeURIComponent(rawUrl)}`;
      return width ? `${base}&w=${width}` : base;
    }
    return rawUrl;
  } catch {
    return rawUrl;
  }
}

// Deterministic, de-duplicated ordered list of a product's image URLs.
// MUST stay in sync with the backend _product_image_list() ordering so the short
// image URLs (/api/i/{slug}[/n]) map to the same picture on both sides.
export function productImages(product) {
  const ordered = [];
  const add = (v) => {
    if (v && typeof v === 'string' && !ordered.includes(v)) ordered.push(v);
  };
  if (product) {
    add(product.image);
    (product.galleryImages || []).forEach(add);
    Object.values(product.colorImages || {}).forEach(add);
    (product.images || []).forEach(add);
  }
  return ordered;
}

// Clean, shareable product image URL, e.g. https://.../api/i/tenjam-rad-pad-caddy
// Falls back to the standard proxy URL if the image isn't part of the product's set.
export function productImgUrl(product, rawUrl, width) {
  if (!product || !product.slug || !rawUrl) return imgUrl(rawUrl, width);
  const idx = productImages(product).indexOf(rawUrl);
  if (idx < 0) return imgUrl(rawUrl, width);
  const base = `${BACKEND_URL}/api/i/${product.slug}${idx === 0 ? '' : '/' + (idx + 1)}`;
  return width ? `${base}?w=${width}` : base;
}
